<template>
  <div class="d-flex justify-end mb-0">
    <v-btn color="error" @click="deleteLogin"
      ><v-icon>mdi-trash-can</v-icon></v-btn
    >
  </div>
</template>

<script>
import Vue from "vue";
export default Vue.extend({
  name: "ActionButtons",
  methods: {
    deleteLogin() {
      const vm = this;
      vm.params.delete(vm.params.data);
    }
  }
});
</script>

<style lang="scss" scoped></style>
